import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import parse from "html-react-parser";
import * as cmsServices from "../services/cms.services";
import Loader from "../../admin/common/loader";
import dinoLogo from "../../../assets/admin/img/Dino-Land-logo.png";

const CMSPage = ({ fixedSlug }) => {
    const { slug: paramSlug } = useParams();
    const slug = fixedSlug || paramSlug;
    const [pageData, setPageData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPageData = async () => {
            setLoading(true);
            try {
                const response = await cmsServices.getCMSPage(slug);
                if (response.success) {
                    setPageData(response.data);
                } else {
                    setError(response.message || "Page not found");
                }
            } catch (err) {
                console.error("Error fetching CMS page:", err);
                setError("Something went wrong while fetching the page.");
            } finally {
                setLoading(false);
            }
        };

        if (slug) {
            fetchPageData();
        }
    }, [slug]);

    if (loading) {
        return <Loader />;
    }

    if (error) {
        return (
            <div className="container mt-5">
                <div className="alert alert-danger" role="alert">
                    {error}
                </div>
            </div>
        );
    }

    if (!pageData) {
        return (
            <div className="container mt-5">
                <div className="alert alert-warning" role="alert">
                    Page not found.
                </div>
            </div>
        );
    }

    return (
        <div className="cms-page-container py-5">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <div className="text-center mb-4">
                            <Link to="/">
                                <img src={dinoLogo} alt="Dino Land Logo" style={{ width: "120px", cursor: "pointer" }} className="dino-bounce" />
                            </Link>
                        </div>
                        <div className="card shadow-lg border-0 dino-card">
                            <div className="card-body p-4 p-md-5">
                                <h1 className="mb-4 text-center dino-title">{pageData.title}</h1>
                                {pageData.short_description && (
                                    <p className="lead mb-4 text-center dino-subtitle">
                                        {pageData.short_description}
                                    </p>
                                )}
                                <div className="dino-divider mb-4"></div>
                                <div className="cms-content mt-4">
                                    {pageData.description ? parse(pageData.description) : "No content available."}
                                </div>
                                <div className="text-center mt-5">
                                    <Link to="/" className="btn btn-dino-back px-5 py-2 fw-bold">
                                        Back to Home
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Fredoka+One&display=swap');

                .cms-page-container {
                    background: linear-gradient(135deg, #68e1fd 0%, #fbd53d 100%);
                    min-height: 100vh;
                    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                }
                .dino-card {
                    border-radius: 2rem;
                    background: rgba(255, 255, 255, 0.95);
                    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1) !important;
                }
                .dino-title {
                    font-family: 'Fredoka One', cursive;
                    color: #36594C;
                    font-size: 2.5rem;
                    letter-spacing: 1px;
                }
                .dino-subtitle {
                    color: #557a6b;
                    font-style: italic;
                    font-size: 1.1rem;
                }
                .dino-divider {
                    height: 4px;
                    background: linear-gradient(90deg, transparent, #68e1fd, #fbd53d, transparent);
                    border-radius: 2px;
                }
                .cms-content {
                    line-height: 1.8;
                    color: #2b4231;
                    font-size: 1.05rem;
                }
                .cms-content p {
                    margin-bottom: 1.5rem;
                }
                .cms-content h2, .cms-content h3 {
                    font-family: 'Fredoka One', cursive;
                    color: #36594C;
                    margin-top: 2.5rem;
                    margin-bottom: 1.2rem;
                }
                .cms-content strong {
                    color: #1a2e25;
                }
                .cms-content ul, .cms-content ol {
                    margin-bottom: 1.5rem;
                    padding-left: 1.5rem;
                }
                .cms-content li {
                    margin-bottom: 0.8rem;
                }
                .btn-dino-back {
                    background: linear-gradient(135deg, #fc6767, #ec008c);
                    color: #fff;
                    border: 0;
                    border-radius: 50px;
                    transition: all 0.3s ease;
                    text-transform: uppercase;
                    letter-spacing: 1px;
                }
                .btn-dino-back:hover {
                    transform: scale(1.05);
                    color: #fff;
                    box-shadow: 0 5px 15px rgba(236, 0, 140, 0.4);
                }
                .dino-bounce {
                    animation: bounce 2s infinite;
                }
                @keyframes bounce {
                    0%, 100% { transform: translateY(0); }
                    50% { transform: translateY(-15px); }
                }
                @media (max-width: 768px) {
                    .dino-title {
                        font-size: 1.8rem;
                    }
                    .cms-page-container {
                        padding-top: 2rem;
                        padding-bottom: 2rem;
                    }
                }
            `}</style>
        </div>
    );
};

export default CMSPage;
